
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _reportsn7pKLl1DVxzMp8JjF3OeY0XFUM2Udg_PsT5mO00UHy8Meta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/_reports.vue?macro=true";
import { default as _91_46_46_46slug_93p9YyCqJ3W14WBnxYzsg03awu8DIc_45bEbS4aUborZzdYMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/[...slug].vue?macro=true";
import { default as _kitchen_45sinkBv_45iDjtih9YjBqPOIdV9_45MA5MUTlz5hVC8hxr4Rj5OYMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/_kitchen-sink.vue?macro=true";
import { default as readykRkcnjlXUKk9DC1FaetYa5B4M_45eu8NVEBmo_rU8zynIMeta } from "/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/_probes/nuxt/ready.vue?macro=true";
export default [
  {
    name: "_reports",
    path: "/_reports",
    meta: _reportsn7pKLl1DVxzMp8JjF3OeY0XFUM2Udg_PsT5mO00UHy8Meta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/_reports.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: {"middleware":"headless"},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/[...slug].vue")
  },
  {
    name: "_kitchen-sink",
    path: "/_kitchen-sink",
    meta: _kitchen_45sinkBv_45iDjtih9YjBqPOIdV9_45MA5MUTlz5hVC8hxr4Rj5OYMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/_kitchen-sink.vue")
  },
  {
    name: "_probes-nuxt-ready",
    path: "/_probes/nuxt/ready",
    meta: readykRkcnjlXUKk9DC1FaetYa5B4M_45eu8NVEBmo_rU8zynIMeta || {},
    component: () => import("/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1164_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5_typescript@5.8.3_vue@3.5.14_typescript@5.8.3_/node_modules/@edco/apollo/src/pages/_probes/nuxt/ready.vue")
  }
]